/**
 * 100vw doesn't take into account the vertical scrollbar,
 * causing 100vw to create a horizontal scrollbar.
 * This is a little hack to take into account the scrollbar width.
 */
const vwHack = () => {
	const vwSetter = () => {
		const vw = document.documentElement.clientWidth / 100;
		document.documentElement.style.setProperty('--vw', `${vw}px`);
	};

	vwSetter();

	window.addEventListener('resize', vwSetter);
};

export default vwHack;
